const equipmentList = {
  "belongs-to": "Pertenece A",
  "v-card-title": "Activos",
  plantList: "Áreas",
  operations: "Estatus de Operaciones",
  "label-search": "Buscar",
  "span-equipment-profile": "Perfil de Activo",
  "span-statitics": "Gráficas",
  "span-inspections-list": "Revisar Inspecciones de este Activo",
  "span-new-inspections": "Nueva Inspeccion",
  "span-repair-list": "Revisar Registro de reparaciones de este activo",
  "span-new-repair-logs": "Registrar nueva reparacion",
  equipImg: "Imagen de Activo",
  equipTag: "Tag del Activo",
  status: "Estatus de Confiabilidad",
  equipType: "Tipo de Activo",
  customer: "Compañia",
  area: "Area",
  plant: "Edificio",
  unit: "Unidad",
  profile: "Perfil",
  statitics: "Gráficas",
  inspections: "Inspección",
  reliability: "Confiabilidad",
  "repair-logs": "Reparación",
  scanAndInspect: "Escanea e Inspecciona",
  reportError: "Soporte Técnico",
  cancel: "Cancelar",
  scanQR: "Escaneo de QR",
  running: "En Servicio",
  zones: {
    zone: "Zona",
    smooth: "Optimo",
    warning: "Advertencia",
    alarm: "Alarma"
  },
  pilot: "HOUSTON"
};

export default equipmentList;
